import { Button, message, Select, Space } from "antd";
import { useState } from "react";
import api from "../../../../api/api";

const OrderProductEditor = ({ order, canEdit, onChanged }) => {
  const [editing, setEditing] = useState(false);
  const [products, setProducts] = useState([]);
  const [productId, setProductId] = useState();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const startEditing = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/order/product-options");
      setProducts(data);
      setProductId(order.productId);
      setEditing(true);
    } catch {
      message.error("خطا در دریافت لیست محصولات");
    } finally {
      setLoading(false);
    }
  };

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/order/${order.orderId}/product`, {
        productId,
      });
      onChanged(data);
      setEditing(false);
      message.success("محصول سفارش با موفقیت تغییر کرد");
    } catch {
      message.error("خطا در تغییر محصول سفارش");
    } finally {
      setSaving(false);
    }
  };

  if (!editing || !canEdit) {
    return (
      <Space direction="vertical">
        <span>{order.productTitle || "-"}</span>
        {canEdit && order.orderId && (
          <Button size="small" onClick={startEditing} loading={loading}>
            تغییر محصول
          </Button>
        )}
      </Space>
    );
  }

  return (
    <Space direction="vertical" style={{ width: "100%", minWidth: 220 }}>
      <Select
        aria-label="محصول سفارش"
        showSearch
        optionFilterProp="label"
        placeholder="انتخاب محصول"
        style={{ width: "100%" }}
        value={productId}
        onChange={setProductId}
        disabled={saving}
        options={products.map((product) => ({
          value: product.id,
          label: `${product.privateTitle || product.title} (${product.code})${
            product.active ? "" : " - غیرفعال"
          }`,
        }))}
      />
      <Space>
        <Button
          type="primary"
          size="small"
          loading={saving}
          disabled={!productId || productId === order.productId}
          onClick={save}
        >
          ذخیره
        </Button>
        <Button size="small" disabled={saving} onClick={() => setEditing(false)}>
          انصراف
        </Button>
      </Space>
    </Space>
  );
};

export default OrderProductEditor;
